module.exports = __webpack_public_path__ + "static/media/INDOOR_OUTDOOR.19409a84.svg";